/** Merge `defaultValue` from admin field configs — one source of truth with the CMS form. */
export function widgetDefaultsFromFields(
  fields: ReadonlyArray<{ fieldName?: string; defaultValue?: unknown }>,
): Record<string, unknown> {
  return fields.reduce<Record<string, unknown>>((acc, field) => {
    if (field.fieldName != null && field.defaultValue !== undefined) {
      acc[field.fieldName] = field.defaultValue;
    }
    return acc;
  }, {});
}
